// ./client/src/api/announcementAPI.js

import axiosInstance from '../utilities/axiosInstance';

const announcementAPI = {
  // ============================================================================
  // ANNOUNCEMENT MANAGEMENT
  // ============================================================================

  // Send announcement to students
  sendAnnouncement: async (announcementData) => {
    try {
      const response = await axiosInstance.post('/api/announcement/sendAnnouncement', announcementData);
      return response.data; // {success, message, announcementId, totalStudents, successCount, recipients}
    } catch (error) {
      return error?.response?.data || { 
        success: false, 
        error: `Failed to send announcement: ${error.message}` 
      };
    }
  },

  // Get announcement history for instructor
  getAnnouncementHistory: async (instructorId, page = 1, limit = 50) => {
    try {
      const response = await axiosInstance.get(
        `/api/announcement/getAnnouncementHistory/${instructorId}`,
        { params: { page, limit } }
      );
      return response.data; // {success, announcements, total, page, totalPages}
    } catch (error) {
      return error?.response?.data || { 
        success: false, 
        error: `Failed to get announcement history: ${error.message}` 
      };
    }
  },

  getAdminAnnouncementHistory: async (page = 1, limit = 50) => {
    try {
      const response = await axiosInstance.get(
        `/api/announcement/getAdminAnnouncementHistory`,
        { params: { page, limit } }
      );
      return response.data; // {success, announcements, total, page, totalPages}
    } catch (error) {
      return error?.response?.data || { 
        success: false, 
        error: `Failed to get admin announcement history: ${error.message}` 
      };
    }
  },

  // Get announcements for student
  getStudentAnnouncements: async (studentId, page = 1, limit = 20) => {
    try {
      const response = await axiosInstance.get(
        `/api/announcement/getStudentAnnouncements/${studentId}`,
        { params: { page, limit } }
      );
      return response.data; // {success, announcements, total, page, totalPages}
    } catch (error) {
      return error?.response?.data || { 
        success: false, 
        error: `Failed to get student announcements: ${error.message}` 
      };
    }
  },

  // Get unread announcement count for user
  getUnreadAnnouncementCount: async (userId) => {
    try {
      const response = await axiosInstance.get(
        `/api/announcement/getUnreadAnnouncementCount/${userId}`
      );
      return response.data; // {success, unreadCount}
    } catch (error) {
      return error?.response?.data || { 
        success: false, 
        error: `Failed to get unread announcement count: ${error.message}`,
        unreadCount: 0
      };
    }
  },

  // Mark announcement as read
  markAnnouncementAsRead: async (announcementId, studentId) => {
    try {
      const response = await axiosInstance.post('/api/announcement/markAnnouncementAsRead', {
        announcementId,
        studentId
      });
      return response.data; // {success, message}
    } catch (error) {
      return error?.response?.data || { 
        success: false, 
        error: `Failed to mark announcement as read: ${error.message}` 
      };
    }
  },

  // Delete announcement
  deleteAnnouncement: async (announcementId, instructorId) => {
    try {
      const response = await axiosInstance.delete(
        `/api/announcement/deleteAnnouncement/${announcementId}`,
        { data: { instructorId } }
      );
      return response.data; // {success, message}
    } catch (error) {
      return error?.response?.data || { 
        success: false, 
        error: `Failed to delete announcement: ${error.message}` 
      };
    }
  },

  // Send admin announcement to users
  sendAdminAnnouncement: async (announcementData) => {
    try {
      const response = await axiosInstance.post('/api/announcement/sendAdminAnnouncement', announcementData);
      return response.data; // {success, message, announcementId, totalUsers, sentCount, recipients}
    } catch (error) {
      return error?.response?.data || { 
        success: false, 
        error: `Failed to send admin announcement: ${error.message}` 
      };
    }
  },

};

export default announcementAPI;